export default {
  categoryList: (state) => state.categoryList.list,
  menuList: (state) => state.menuList.list,
  menuCount: (state) => state.menuList.count,
  menuDetail: (state) => state.menuDetail,
};
